import { memo } from 'react'
import { DeemedPopup } from 'components/dialog/Modals'
import Loading from 'components/loading/Loading'
import { useSelector } from 'react-redux'

const BackDrop = memo(() => {
  const { isLoading } = useSelector(state => state.backDrop)
  return (
    <DeemedPopup on={isLoading}>
      <Loading color="white" size="big" />
    </DeemedPopup>
  )
})
BackDrop.displayName = 'BackDrop'
export default BackDrop
